import { FormControl, Grid, TextField } from '@mui/material';
import MDButton from '@components/MDButton';
import { useMaterialUIController } from 'context';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    searchFilter: string;
    setSearchFilter: (v: string) => void;
    onSearch: () => void;
    onClear: () => void;
    onEnter: (e: React.KeyboardEvent) => void;
}

export const ProfileFilter = ({ searchFilter, setSearchFilter, onSearch, onClear, onEnter }: Props) => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const { sidenavColor, darkMode } = controller;
    const isMobile: boolean = window.innerWidth <= 768;

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    return (
        <Grid container size={{ xs: 12, md: 10 }} spacing={1} alignItems="center">
            <Grid size={isMobile ? 12 : 3}>
                <FormControl fullWidth>
                    <TextField
                        inputRef={inputRef}
                        placeholder={t('perfis.buscarPlaceholder')}
                        size="medium"
                        value={searchFilter}
                        onChange={(e) => setSearchFilter(e.target.value)}
                        onKeyDown={onEnter}
                        autoComplete="off"
                        sx={{
                            backgroundColor: darkMode ? '#141c2b' : 'inherit',
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, md: 'auto' }} sx={{ display: 'flex', gap: 1 }}>
                <MDButton variant="gradient" color={sidenavColor} onClick={onSearch} sx={{ height: 40, minWidth: 110 }}>
                    {t('general.buscar')}
                </MDButton>
                <MDButton variant="gradient" color={sidenavColor} onClick={onClear} sx={{ height: 40, minWidth: 110 }}>
                    {t('general.limpar')}
                </MDButton>
            </Grid>
        </Grid>
    );
};
